import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useStoryIdFromUrl = () => {
  const {prefixedStoryId} = useParams<{prefixedStoryId?: string}>();
  return getEntityIdFromRouteParam(prefixedStoryId);
};
